// src/components/PaymentFlow/LoanList.js
import React from 'react';
import LoanCard from './LoanCard';
import Skeleton from 'react-loading-skeleton';

const LoanList = ({ loans, onInstallmentSelection, loading, clientId }) => {
  if (loading) {
    return (
      <>
        {[1, 2, 3].map((n) => (
          <div key={n} className="mb-3">
            <Skeleton height={69} />
          </div>
        ))}
      </>
    );
  }

  return (
    <>
      {loans.map((loan) => (
        <LoanCard
          key={loan.loanId}
          loan={loan}
          clientId={clientId}
          onInstallmentSelection={onInstallmentSelection}
        />
      ))}
    </>
  );
};

export default LoanList;
